export default "__VITE_ASSET__BylEFIjc__"